import { resolvePhpApiEndpointApp } from "../../features/axios-instances/php-api-endpoint-app";

export const config = {
  get msApiEndpointApp(): string {
    return resolvePhpApiEndpointApp(
      import.meta.env.VITE_MS_API_ENDPOINT_APP ?? "",
    );
  },
};
